import React from 'react';
import { HilbiAlertSC } from './hilbi-alert.styled';

const HilbiAlert: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <HilbiAlertSC>
      <img
        className="alert-avatar"
        src={require('../../assets/svg/hilbi-avatar.svg').default}
        alt="Hilbi"
      />
      {children}
    </HilbiAlertSC>
  );
};

export default HilbiAlert;
